import * as Types from '../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateGhostwriterResponseSetMutationVariables = Types.Exact<{
  input: Types.CreateGhostwriterResponseSetInput;
}>;


export type CreateGhostwriterResponseSetMutation = { __typename?: 'Mutation', ghostwriter: { __typename?: 'GhostwriterMutations', createResponseSet: { __typename?: 'CreateGhostwriterResponseSetPayload', responseSet?: { __typename?: 'GhostwriterResponseSet', id: string, isUserApproved: boolean, createdAt: string } | null, userErrors: Array<{ __typename?: 'GhostwriterUserError', message: string, field?: Array<string> | null, code?: string | null }> } } };


export const CreateGhostwriterResponseSetDocument = gql`
    mutation CreateGhostwriterResponseSet($input: CreateGhostwriterResponseSetInput!) {
  ghostwriter {
    createResponseSet(input: $input) {
      responseSet {
        id
        isUserApproved
        createdAt
      }
      userErrors {
        message
        field
        code
      }
    }
  }
}
    `;
export type CreateGhostwriterResponseSetMutationFn = Apollo.MutationFunction<CreateGhostwriterResponseSetMutation, CreateGhostwriterResponseSetMutationVariables>;

/**
 * __useCreateGhostwriterResponseSetMutation__
 *
 * To run a mutation, you first call `useCreateGhostwriterResponseSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGhostwriterResponseSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGhostwriterResponseSetMutation, { data, loading, error }] = useCreateGhostwriterResponseSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGhostwriterResponseSetMutation(baseOptions?: Apollo.MutationHookOptions<CreateGhostwriterResponseSetMutation, CreateGhostwriterResponseSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGhostwriterResponseSetMutation, CreateGhostwriterResponseSetMutationVariables>(CreateGhostwriterResponseSetDocument, options);
      }
export type CreateGhostwriterResponseSetMutationHookResult = ReturnType<typeof useCreateGhostwriterResponseSetMutation>;
export type CreateGhostwriterResponseSetMutationResult = Apollo.MutationResult<CreateGhostwriterResponseSetMutation>;
export type CreateGhostwriterResponseSetMutationOptions = Apollo.BaseMutationOptions<CreateGhostwriterResponseSetMutation, CreateGhostwriterResponseSetMutationVariables>;